import React, { useState, useEffect } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import AddCircle from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
// @material-ui/core components
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { getAllVendors as getVendorList } from '../../store/actions/admin/Admin';
import { connect } from 'react-redux';
import {
  getCategory as getCategoryList,
  getSupercategoryDetails,
  deleteSuperCategories
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const CategoryTableList = (props) => {
  const classes = useStyles();

  useEffect(() => {
    props.getCategoryList(1);
  }, []);

  const [valueUserLoginType, setUserType] = React.useState(
    localStorage.getItem('userLoginType') || ''
  );

  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [page, setPage] = useState(1);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);

  const fetchDetails = async (superCategoryId) => {
    // props.getSupercategoryDetails(superCategoryId);
  };

  const handleDelete = (superCategoryId) => {
    props.deleteSuperCategories(superCategoryId).then((data) => {
      if (data) {
        props.getCategoryList(1);
      }
    });
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getCategoryList(value);
  };
  return (
    <>
      <CardHeader color="primary">
        {valueUserLoginType !== 'admin' ? (window.location.href = '/') : ''}
        <h4 className={classes.cardTitleWhite}>
          All super-categories - Add, Update, Delete
        </h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Added By</th>
            <th>Name</th>
            <th>Icon</th>
            <th>Category</th>
            <th>Add</th>
            <th>Update</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.superCategories.length !== 0 ? (
            props.superCategories.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                {props.allVendors.filter(
                  (categorieFilter) => categorieFilter.id === item.addedBy
                ).length > 0 ? (
                  props.allVendors
                    .filter(
                      (categorieFilter) => categorieFilter.id === item.addedBy
                    )
                    .map((type) => <td key={type.id}>{type.name}</td>)
                ) : (
                  <td> A {item.userRoleOfAddedBy} </td>
                )}
                <td>{item.name}</td>
                <td>
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{ height: '70px' }}
                  />
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={'/admin/all-category/' + item.id}
                  >
                    View All
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={'/admin/add-category/' + item.id}
                  >
                    <AddCircle
                      onClick={function (event) {
                        toggle();
                        fetchDetails(item.id);
                      }}
                    />{' '}
                    Add category
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#000' }}
                    to={'/admin/super-category-edit/' + item.id}
                  >
                    <EditIcon />
                  </Link>
                </td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemDelete(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination
        count={props.pageCount && props.pageCount - 1}
        color="primary"
        page={page}
        onChange={handlePagination}
      />
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>
          Do you really want to delete this Super Category??
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a super category</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link to="/admin/add-super-category">
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ marginTop: '22px', fontWeight: 600 }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allVendors: state.admin.allVendors,
  superCategories: state.admin.superCategories,
  superCategoryDetails: state.admin.superCategoryDetails,
  pageCount: state.admin.pageCount
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: (id) => dispatch(getCategoryList(id)),
    getVendorList: () => dispatch(getVendorList()),
    getSupercategoryDetails: (superCategoryId) =>
      dispatch(getSupercategoryDetails(superCategoryId)),
    deleteSuperCategories: (superCategoryId) =>
      dispatch(deleteSuperCategories(superCategoryId))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(CategoryTableList);
